export default "__VITE_ASSET__CHV3hg9W__"